import { ValidateNested, IsObject, IsDefined } from 'class-validator';
import { Type } from 'class-transformer';
import { LinkStyleDto } from './LinkStyleDto';

export class LinkCollectionDto {
  @IsDefined()
  @ValidateNested()
  @Type(() => LinkStyleDto)
  @IsObject()
  link1!: LinkStyleDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => LinkStyleDto)
  @IsObject()
  link2!: LinkStyleDto;
}
